/* import __COLOCATED_TEMPLATE__ from './modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { TasksKitSignature } from 'volta/components/tasks-kit';

export interface TasksModalSignature {
  Args: TasksKitSignature['Args'] & {
    disabled?: boolean;
    inPage?: boolean;
    isLoading?: boolean;
    onClose: () => void;
    showDismiss?: boolean;
    translucentBackdrop?: boolean;
    authorizedUsers?: string[];
  };
  Element: HTMLElement;
}

const TasksModalComponent = templateOnlyComponent<TasksModalSignature>();

export default TasksModalComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Tasks::Modal': typeof TasksModalComponent;
    'tasks/modal': typeof TasksModalComponent;
  }
}
